var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.00.-Students-(Admin)",
    transform: "translate(-24.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic-/-Home-/-Active",
    transform: "translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(1.000000, 3.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,18 L16,16 C16,13.790861 14.209139,12 12,12 L4,12 C1.790861,12 0,13.790861 0,16 L0,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18 L22,16 C21.9986403,14.1771177 20.7649988,12.5857202 19,12.13",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.13 C16.7699148,0.583169788 18.0078433,2.17799115 18.0078433,4.005 C18.0078433,5.83200885 16.7699148,7.42683021 15,7.88",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.4545fa1c.svg";
export { ForwardRef as ReactComponent };